<template>
    <div class="w-full h-full flex flex-col justify-center py-12">
        <div class="relative sm:pt-32 sm:mx-auto sm:w-full sm:max-w-4xl">
            <div class="bg-white py-16 px-4 shadow sm:rounded-lg sm:px-10">
                <img
                    class="mx-auto h-12 w-auto mb-10"
                    src="@/assets/logo-full.png"
                    alt="upyield logo"
                >
                <h2
                    v-if="!id || !hash || !expires"
                    class="mt-6 text-center text-2xl text-red-600"
                >
                    Invalid URL params
                </h2>
                <h2
                    v-else-if="isVerified !== true && isVerified !== false"
                    class="mt-3 text-center text-2xl text-red-600"
                >
                    {{ isVerified }}
                </h2>
                <h2
                    v-else
                    v-loading="!isVerified"
                    class="mt-3 text-center text-2xl text-gray-900"
                >
                    <span v-show="isVerified">
                        Thank you for verifying your e-mail address. We will get back to you shortly, once your account has been reviewed.
                    </span>
                </h2>
            </div>
        </div>
    </div>
</template>

<script>

import api from '@/api';
import config from '@/config';
import { getErrorsMessagesFromRequest } from 'shared-lib/helpers/errors';

export default {
    name: 'Verify',

    props: {
        id: {
            type: [String, Number],
            required: true,
        },
        hash: {
            type: String,
            required: true,
        },
        expires: {
            type: String,
            required: true,
        },
    },

    data () {
        return {
            config,
            isVerified: false,
            uploadHost: process.env.VUE_APP_UPLOADS_HOST,
        };
    },

    computed: {
    },

    created () {
        if (!this.id || !this.hash || !this.expires) {
            setTimeout(() => this.$router.push({ name: 'resetPassword' }), 4000);
        } else {
            api.verify.get(this.id, { signature: this.hash, expires: this.expires }, { ignoredErrorCodes: [409] })
                .then(() => this.isVerified = true)
                .catch((e) => {
                    const errorStatusCode = e?.response?.status;
                    let errors;

                    if (errorStatusCode === 409) {
                        errors = 'The verification link has either expired or has already been used';
                    } else {
                        errors = getErrorsMessagesFromRequest(e);
                    }

                    this.isVerified = Array.isArray(errors) ? errors[0] : errors;
                });
        }
    },
};
</script>

<style lang="scss" scoped>
</style>
